module.exports = __webpack_public_path__ + "img/Human Resource.cf6c8ee5.svg";